module.exports = __webpack_public_path__ + "img/contact_icon.dbb4e683.svg";